var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletConnect2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 2.48682C18.5894 2.48682 23.93 7.86449 23.93 14.4998C23.93 21.135 18.5894 26.5127 11.9999 26.5127C5.41041 26.5127 0.0698242 21.135 0.0698242 14.4998C0.0698242 7.86449 5.41041 2.48682 11.9999 2.48682Z",
    fill: "url(#paint0_radial_2682_32513)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65175 11.7639C10.0518 9.40356 13.9477 9.40356 16.3477 11.7639L16.6366 12.0502C16.7578 12.1675 16.7578 12.3599 16.6366 12.4772L15.6486 13.4485C15.5881 13.5096 15.4902 13.5096 15.4296 13.4485L15.0335 13.0591C13.3558 11.412 10.6436 11.412 8.96593 13.0591L8.54185 13.4767C8.48127 13.5377 8.3834 13.5377 8.32282 13.4767L7.33486 12.5053C7.2137 12.388 7.2137 12.1956 7.33486 12.0783L7.65175 11.7639ZM18.3935 13.7723L19.2743 14.6358C19.3954 14.7531 19.3954 14.9455 19.2743 15.0628L15.3085 18.9623C15.1873 19.0796 14.9916 19.0796 14.8751 18.9623L12.0603 16.1937C12.0323 16.1655 11.9811 16.1655 11.9531 16.1937L9.13836 18.9623C9.01719 19.0796 8.82146 19.0796 8.70496 18.9623L4.72515 15.0628C4.60399 14.9455 4.60399 14.7531 4.72515 14.6358L5.60593 13.7723C5.72709 13.655 5.92282 13.655 6.03933 13.7723L8.85408 16.5409C8.88204 16.5691 8.93331 16.5691 8.96127 16.5409L11.776 13.7723C11.8972 13.655 12.0929 13.655 12.2094 13.7723L15.0242 16.5409C15.0521 16.5691 15.1034 16.5691 15.1314 16.5409L17.9461 13.7723C18.0766 13.655 18.2723 13.655 18.3935 13.7723Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2682_32513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.0698982 14.5001) scale(23.8602 24.0259)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect2);
export default __webpack_public_path__ + "static/media/walletConnect2.212b6cf0ff62bef6a70235ed10722bff.svg";
export { ForwardRef as ReactComponent };